var map = {
	"./conditions-off-piste.svg": 816,
	"./conditions-piste.svg": 817,
	"./conditions-runs.svg": 818,
	"./next-significant-snowfall.svg": 819,
	"./next-snowfall.svg": 820
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 815;